export const LOADING_STEP = 'loading';
export const PINWHEEL_STEP = 'pinwheel';
export const NON_PINWHEEL_STEP = 'nonPinwheel';
export const PERPAY_SPLIT_STEP = 'perpaySplit';
export const PINWHEEL_SPLIT_STEP = 'pinwheelSplit';
